<div class="modal-footer justify-content-between">
  <button
    type="button"
    class="btn btn-default"
    [disabled]="cancelDisabled"
    (click)="onCancelClick.emit()"
  >
    {{ cancelLabel }}
  </button>
  <button type="submit" class="btn btn-default" [disabled]="saveDisabled">
    {{ saveLabel }}
    <i class="fa fa-spinner fa-pulse ml-2" *ngIf="loadingIndicator"></i>
  </button>
</div>
